import { filter} from 'rxjs/operators';
import { Component, OnInit, NgModule, ChangeDetectorRef, Input, Output, EventEmitter, ElementRef, ViewChild,NgZone,SimpleChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import { DocumentsService } from '../../services/check.lists.service';
import { CheckListsUtilsService } from '../../services/check.lists.utils.service';
import { any, val } from '@uirouter/core';
import { NONE_TYPE } from '@angular/compiler/src/output/output_ast';
import { I18nService } from 'core-app/modules/common/i18n/i18n.service';
import { Observable, fromEvent, from , forkJoin}from 'rxjs';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';


declare let laydate: any;



@Component({
  selector: 'check_lists-quest4',
  templateUrl: './check_lists-quest4.component.html',
  styleUrls: ['./check_lists-quest4.component.sass']
})
@NgModule({
  imports: [CommonModule]
})
export class Check_listsQuest4Component implements OnInit {

  @Input() public check_listsID:any
  @Input() public kind_id:any

  @Output() close = new EventEmitter();
  @ViewChild('uploadFileRef', { static: false }) uploadFileRef: ElementRef;
  @ViewChild('uploadPdfFileRef', { static: false }) uploadPdfFileRef: ElementRef;
  @ViewChild ('outputPdf',{static:false}) downPdf:ElementRef


  constructor(
    protected cdRef:ChangeDetectorRef,
    public service: DocumentsService,
    private zone: NgZone,
    public i18n: I18nService,
    public utils: CheckListsUtilsService,
  ) { }

  // public data:any={"result":"ok","check_list":{"id":2,"check_list_type_id":null,"check_list_template_id":1,"created_by_id":2,"updated_by_id":3,"assigned_to_id":null,"expected_finish_at":null,"start_at":null,"end_at":null,"description":null,"check_list_location_id":null,"created_at":"06/04/2020/ 16:50 PM","updated_at":"06/04/2020/ 16:50 PM","project_id":null,"label":null,"name":null,"check_list_metum":{"id":2,"parts":[{"items":[{"type":"text","title":"Scheduled Time of Inspection","value":"41545151515","default":"12:00","options":null,"description":"Normally this inspection will be walk through the site and\nwill take at least 1 hour. Please use international time format,\ne.g. 13:30"},{"type":"text","title":"Locations","value":"","default":"Drainage 1 to 13","options":null,"description":""},{"type":"radio","title":"Weather","value":null,"default":0,"options":["Sunny","Cloudy","Rainy"],"description":null},{"type":"text","title":"Temperature","value":null,"default":35,"options":null,"description":"Degree Celsius"},{"type":"text","title":"Humidity","value":"45485151515","default":86,"options":null,"description":"Percentage"},{"type":"text","title":"Person(s) doing inspection","value":null,"default":"Jhon Doe/IOW/AECOM","options":null,"description":"Name / Title / Organisation"}],"title":"Waste Water Inspection","description":"descriptions of waste water inspection"},{"items":[{"type":"radio","title":"Is wastewater discharge License provided?","value":null,"default":null,"options":["是","否","无"],"description":null},{"type":"checkbox","title":"Time","value":[0,1],"default":null,"options":["AM","PM"],"desription":null}],"title":"Water Discharge License","description":"Note: This is a documentary check, photo or document record may be necessary.HS"}],"signs":[{"user_id":3}],"check_list_id":2,"created_at":"06/04/2020/ 16:50 PM","updated_at":"06/04/2020/ 16:50 PM"}}}
  public data:any={"result":"ok","check_list":{"id":2,"check_list_type_id":null,"check_list_template_id":1,"created_by_id":2,"updated_by_id":3,"assigned_to_id":null,"expected_finish_at":null,"start_at":null,"end_at":null,"description":null,"check_list_location_id":null,"created_at":"06/04/2020/ 16:50 PM","updated_at":"06/04/2020/ 16:50 PM","project_id":null,"label":null,"name":null,"check_list_metum":{"id":2,"parts":[{"items":[{"type":"text","title":"Scheduled Time of Inspection","value":"41545151515","default":"12:00","options":null,"description":"Normally this inspection will be walk through the site and\\nwill take at least 1 hour. Please use international time format,\\ne.g. 13:30"},{"type":"text","title":"Locations","value":"","default":"Drainage 1 to 13","options":null,"description":""},{"type":"radio","title":"Weather","value":null,"default":0,"options":["Sunny","Cloudy","Rainy"],"description":null},{"type":"radio_sign_date","title":"Weather","value":null,"default":0,"options":["Sunny","Cloudy","Rainy"],"sign_id":null,"sign_data":null,"description":null},{"type":"text","title":"Temperature","value":null,"default":35,"options":null,"description":"Degree Celsius"},{"type":"text","title":"Humidity","value":"45485151515","default":86,"options":null,"description":"Percentage"},{"type":"text","title":"Person(s) doing inspection","value":null,"default":"Jhon Doe/IOW/AECOM","options":null,"description":"Name / Title / Organisation"}],"title":"Waste Water Inspection","description":"descriptions of waste water inspection"},{"items":[{"type":"radio","title":"Is wastewater discharge License provided?","value":null,"default":null,"options":["是","否","无"],"description":null},{"type":"radio_sign_date","title":"Weather","value":null,"default":0,"options":["Sunny","Cloudy","Rainy"],"sign_id":null,"sign_data":null,"description":null},{"type":"checkbox","title":"Time","value":[0,1],"default":null,"options":["AM","PM"],"desription":null}],"title":"Water Discharge License","description":"Note: This is a documentary check, photo or document record may be necessary.HS"}],"signs":[{"user_id":3}],"check_list_id":2,"created_at":"06/04/2020/ 16:50 PM","updated_at":"06/04/2020/ 16:50 PM"}}}
  public num:any=0;
  public theCheckbox:any = false
  public indexO:any
  public dipsle:any=true
  public signShow:any=false
  public autographsignitem:any
  public annotationShow:any=false
  public annotationId:any=[]
  public projectId:any
  public userData:any
  public byuserdata:any
  public locationsData:any
  public replyCheckBoolean:any
  public actionCheckBoolean:any
  public userSelect:any
  public count:any=0
  public sum:any=0
  public sum_num:any = 0
  public updateModel:any
  public id:any
  public doc_idImg:any
  public assigned_to_id:any
  public check_list_location_id:any
  public start_at:any
  public end_at:any
  public expected_finish_at:any
  public arr_sum:any=[]
  public show_banner:any=false
  public count_doc:any=[]
  public host:any=window.location.origin
  public arr_doc_img:any=[]
  public doc_item_id:any
  public remark_id:any
  public remark_item:any
  public doc_item:any
  public detailsbottomtext:any
  public issueblock = false
  public reSignLoad:any
  public action_required:any
  public Reply:any
  public groupData:any
  public assigntLoading:any
  //创建前数据
  public fileRefNo: any={};
  //创建后数据
  public fileRefNoInfo:any={};

  //是否显示 fileRefNo
  public isFileRefNo:boolean=false;
  // fileRefNo type
  public fileRefNoType:string;
 //是否在提交中
  public isSubmit:boolean=false;

  public payload:any
  public schema:any
  public showPdfdownload:boolean = true
  public saveRes:any
  public jumpUrl:any
  public signBy:any=[]
  public  needNum:any
  public showNum:boolean = false

  public templateid:any=[]
  public showEditDiv:boolean = false
  public showimgEdit:boolean = false
  public imageData:any ={}
  public tempIndex:any
  public remarkFlag:boolean=true
  public hascount:number=0
  public showLoading:boolean = false

  public inputInfoId=""
  public checklistArr = ['','Checklist','Safety','Cleansing']
  public saveFileFlag:boolean = true
  public checkYes:number
  public allLog: boolean = false
  public secondSign:any
  public fourthSign:any
  public fifthSign:any
  public fourthdocId:any
  public fifthdocId:any
  public userId:any = Number(document.getElementsByName('current_user')[0].dataset.id)
  public dipslesignature = false
  public signloding:any
  public firstSign:any
  public signType:any
  public firstdocId:any
  public seconddocId:any
  public ifCheckAssign:any
  public constructorUserId:any
  public contractorUsers:any
  public checkassightselect:any
  public assignType:any = 'Indlvidual'
  public thirddocId:any
  public searchKeyword:string = ''
  public filteredAssignList:any = []
  public assigned_doc_last_loading:any
  public thirdSign:any
  public defaultDoc = document.getElementsByName('current_user')[0].dataset.sign_doc_id
  // public checklistTypeArr = ['','ChecklistType','SafetyType','CleansingType']
  public imageLeftData:any = new Image()

  public aImage:any
  public fill_env:any
  public choice_env:any
  public isSignBoxItem= false
  public sign_box = { //临时存储的变量
    item:null,
    sub_item:null,
    part:null,
  }
  public special_first_type = ''
  public pdfTemplateid:any=[]
  public safetyData: any = [
    {
      CurrentStatus: 'New',
      NextStatus: 'Assistant Safety Officer Signed',
      RequiredText: 'Action Required',
      img: '',
      remark: '',
      dateTime: '',
      signNext:false,
      signId: '',
      isDefaultSign: false,
      disabled: false,
      userName: '',
      isShowBox: true,
      signloding: false,
    },
    {
      CurrentStatus: 'Assistant Safety Officer Signed',
      NextStatus: 'Safety Officer Signed',
      RequiredText: 'Reply',
      img: '',
      remark: '',
      dateTime: '',
      signId: '',
      signNext:false,
      isDefaultSign: false,
      disabled: false,
      userName: '',
      isShowBox: false,
      signloding: false,
    },
    {
      CurrentStatus: 'Safety Officer Signed',
      NextStatus: 'Site Agent Signed',
      RequiredText: 'Reply',
      img: '',
      remark: '',
      dateTime: '',
      signId: '',
      signNext:false,
      isDefaultSign: false,
      disabled: false,
      userName: '',
      isShowBox: false,
      signloding: false,
    },
    {
      CurrentStatus: 'Site Agent Signed',
      NextStatus: 'Project Manager Signed',
      RequiredText: 'Reply',
      img: '',
      remark: '',
      dateTime: '',
      signId: '',
      signNext:false,
      isDefaultSign: false,
      disabled: false,
      userName: '',
      isShowBox: false,
      signloding: false,
    },
    {
      CurrentStatus: 'Project Manager Signed',
      NextStatus: 'Assistant Safety Officer Second Signed',
      RequiredText: 'Reply',
      img: '',
      remark: '',
      dateTime: '',
      signId: '',
      signNext:false,
      isDefaultSign: false,
      disabled: false,
      userName: '',
      isShowBox: false,
      signloding: false,
    },
    {
      CurrentStatus: 'Assistant Safety Officer Second Signed',
      NextStatus: 'Safety Officer Second Signed',
      RequiredText: 'Reply',
      img: '',
      remark: '',
      dateTime: '',
      signId: '',
      signNext:false,
      isDefaultSign: false,
      disabled: false,
      userName: '',
      isShowBox: false,
      signloding: false,
    },
    {
      CurrentStatus: 'Safety Officer Second Signed',
      NextStatus: 'Site Agent Second Signed',
      RequiredText: 'Reply',
      img: '',
      remark: '',
      dateTime: '',
      signId: '',
      signNext:false,
      isDefaultSign: false,
      disabled: false,
      userName: '',
      isShowBox: false,
      signloding: false,
    },
    {
      CurrentStatus: 'Site Agent Second Signed',
      NextStatus: 'Project Manager Second Signed',
      RequiredText: 'Reply',
      img: '',
      remark: '',
      dateTime: '',
      signId: '',
      signNext:false,
      isDefaultSign: false,
      disabled: false,
      userName: '',
      isShowBox: false,
      signloding: false,
    },
    {
      CurrentStatus: 'Project Manager Second Signed',
      NextStatus: '',
      RequiredText: 'Reply',
      img: '',
      remark: '',
      dateTime: '',
      signId: '',
      signNext:false,
      isDefaultSign: false,
      disabled: false,
      userName: '',
      isShowBox: false,
      signloding: false,
    },
  ]
  public envData:any = [
    {
      CurrentStatus: 'New',
      NextStatus: 'Sent',
      RequiredText: 'Action Required',
      img: '',
      remark: '',
      dateTime: '',
      signNext:false,
      signId: '',
      isDefaultSign: false,
      disabled: false,
      userName: '',
      isShowBox: true,
      signloding: false,
    },
    {
      CurrentStatus: 'Sent',
      NextStatus: "Contractor's Signed",
      RequiredText: 'Reply',
      img: '',
      remark: '',
      dateTime: '',
      signId: '',
      signNext:false,
      isDefaultSign: false,
      disabled: false,
      userName: '',
      isShowBox: false,
      signloding: false,
    },
    {
      CurrentStatus: "Contractor's Signed",
      NextStatus: 'Closed',
      RequiredText: 'Reply',
      img: '',
      remark: '',
      dateTime: '',
      signId: '',
      signNext:false,
      isDefaultSign: false,
      disabled: false,
      userName: '',
      isShowBox: false,
      signloding: false,
    },
    {
      CurrentStatus: 'Closed',
      NextStatus: '',
      RequiredText: 'Reply',
      img: '',
      remark: '',
      dateTime: '',
      signId: '',
      signNext:false,
      isDefaultSign: false,
      disabled: false,
      userName: '',
      isShowBox: false,
      signloding: false,
    }
  ]
  public dcData:any = [
    {
      CurrentStatus: 'New',
      NextStatus: 'Contractor Sent',
      RequiredText: 'Action Required',
      img: '',
      remark: '',
      dateTime: '',
      signNext:false,
      signId: '',
      isDefaultSign: false,
      disabled: false,
      userName: '',
      isShowBox: true,
      signloding: false,
    },
    {
      CurrentStatus: 'Contractor Sent',
      NextStatus: "Engineer's Representative Signed",
      RequiredText: 'Reply',
      img: '',
      remark: '',
      dateTime: '',
      signId: '',
      signNext:false,
      isDefaultSign: false,
      disabled: false,
      userName: '',
      isShowBox: false,
      signloding: false,
    },
    {
      CurrentStatus: "Engineer's Representative Signed",
      NextStatus: 'Closed',
      RequiredText: 'Reply',
      img: '',
      remark: '',
      dateTime: '',
      signId: '',
      signNext:false,
      isDefaultSign: false,
      disabled: false,
      userName: '',
      isShowBox: false,
      signloding: false,
    },
     {
      CurrentStatus: "Closed",
      NextStatus: '',
      RequiredText: 'Reply',
      img: '',
      remark: '',
      dateTime: '',
      signId: '',
      signNext:false,
      isDefaultSign: false,
      disabled: false,
      userName: '',
      isShowBox: false,
      signloding: false,
    },
  ]
  public monData:any = [
    {
      CurrentStatus: 'New',
      NextStatus: 'Contractor SO Signed',
      RequiredText: 'Action Required',
      img: '',
      remark: '',
      dateTime: '',
      signNext:false,
      signId: '',
      isDefaultSign: false,
      disabled: false,
      userName: '',
      isShowBox: true,
      signloding: false,
    },
    {
      CurrentStatus: 'Contractor SO Signed',
      NextStatus: "Closed",
      RequiredText: 'Reply',
      img: '',
      remark: '',
      dateTime: '',
      signId: '',
      signNext:false,
      isDefaultSign: false,
      disabled: false,
      userName: '',
      isShowBox: false,
      signloding: false,
    },
     {
      CurrentStatus: "Closed",
      NextStatus: '',
      RequiredText: 'Reply',
      img: '',
      remark: '',
      dateTime: '',
      signId: '',
      signNext:false,
      isDefaultSign: false,
      disabled: false,
      userName: '',
      isShowBox: false,
      signloding: false,
    },
  ]
  public CurrentData:any = []
  uploadPdf(item:any,i:any){
    if(this.checkDisable()){
      return
    }
    console.log('进了吧');

    this.doc_item = item
    //如果不是同一个item
    this.doc_item_id = i

    this.uploadPdfFileRef.nativeElement.click();
  }
  removePdf(index:any,item:any,subitem:any,bigindex:any){
    this.pdfTemplateid = item
    //console.log(this.pdfTemplateid,index,bigindex)
    var msg = "确定删除PDF吗?";
    if (confirm(msg)==true){
      this.pdfTemplateid.splice(index,1)
    }
    //console.log(this.pdfTemplateid)
    let data={
      part:this.num,
      item:bigindex,
      pdf:this.pdfTemplateid
    }
    this.updateInfo(data)
    this.showEditDiv = false
  }
  selectPdfFile(event:any,item:any,i:any){
    this.showLoading = true
    let files = event.target.files;
    let file = new FormData();
    file.append('file', files[0]);
    this.service.update_PDF({
      p_id:this.id,
      c_id:this.check_listsID,
      file
    }).subscribe((res: any) => {
      if(this.doc_item.props.pdf){
        this.pdfTemplateid = this.doc_item.props.pdf.concat ({
          doc_id:res.doc_id,
          status:''
        })
      }else{
        this.pdfTemplateid.push({
          doc_id:res.doc_id,
          status:''
        })
      }
      let data={
        part:this.num,
        item:this.doc_item_id,
        pdf:this.pdfTemplateid
      }
      this.updateInfo(data)
      this.pdfTemplateid = []
      this.uploadPdfFileRef.nativeElement.value = '';
      this.showLoading = false
    })
  }

  saveStatus(){
      const pandStatus = this.data.check_list.state=="Recheck" || this.data.check_list.state=="Contractor Recheck"? 'New' : this.data.check_list.state
      const saveData = this.CurrentData.find((item:any) => {
        return item.CurrentStatus == pandStatus
      })

    // console.log(saveData,'saveData');
    if(saveData){
      if(saveData.signNext){
        return false
      }else{
        return true
      }
    }else{
      if( this.data.check_list.created_by_id == this.userId){
        return false
      }else{
        return true
      }
    }
    // if(this.data.check_list.state.includes('New') || this.data.check_list.state.includes('Recheck')){
    //   if( this.data.check_list.created_by_id == this.userId){
    //     return false
    //   }else{
    //     return true
    //   }
    // }else if(this.data.check_list.state.includes(this.special_first_type)){
    //   if( this.data.check_list.assigned_to_id == this.userId){
    //     return false
    //   }else{
    //     return true
    //   }
    // }else if(this.data.check_list.state.includes('site agent signed')){
    //   if( this.data.check_list.assigned_to_last_id == this.userId){
    //     return false
    //   }else{
    //     return true
    //   }
    // }else if(this.data.check_list.state.includes('supervisor checked')){
    //   if( this.data.check_list.fourth_sign_user_id == this.userId){
    //     return false
    //   }else{
    //     return true
    //   }
    // }else if (this.data.check_list.state.includes('supervisor_1 signed')){
    //   if( this.data.check_list.fifth_sign_user_id == this.userId){
    //     return false
    //   }else{
    //     return true
    //   }
    // }else{
    //   return true
    // }
  }
  recheckStatus(){
    const data = this.CurrentData.find((item:any) => {
      return item.CurrentStatus == this.data.check_list.state
    })

    if(data){
      if(data.signNext){
        return false
      }else{
        return true
      }
    }
    // else if(this.data.check_list.state.includes('site agent signed')){
    //   if( this.data.check_list.assigned_to_last_id == this.userId){
    //     return false
    //   }else{
    //     return true
    //   }
    // }else if(this.data.check_list.state.includes('supervisor checked')){
    //   if( this.data.check_list.fourth_sign_user_id == this.userId){
    //     return false
    //   }else{
    //     return true
    //   }
    // }else if (this.data.check_list.state.includes('supervisor_1 signed')){
    //   if( this.data.check_list.fifth_sign_user_id == this.userId){
    //     return false
    //   }else{
    //     return true
    //   }
    // }
    else{
      return true
    }
  }
  canNotSignfirst(){
   return this.data.check_list.created_by_id == this.userId && (this.data.check_list.state === 'New' || this.data.check_list.state == 'Recheck' )
  }
  canNotSignsecond(){
    return this.data.check_list.assigned_to_id == this.userId && (this.data.check_list.state === this.special_first_type  )
   }
   canNotSignthird(){
    return this.data.check_list.assigned_to_last_id == this.userId && (this.data.check_list.state === 'site agent signed'  )
   }
   canNotSignfourth(){
    return this.data.check_list.fourth_sign_user_id == this.userId && (this.data.check_list.state === 'supervisor checked'  )
   }
   canNotSignfifth(){
    return this.data.check_list.fifth_sign_user_id == this.userId && (this.data.check_list.state ==='supervisor_1 signed'  )
   }
    // 当前用户
  public currentUser:any = document.querySelector('meta[name=current_user]')
  public isDefaultSign: boolean = false;
  public isShowDefaultSign: boolean = false;
  // 第2个是否能签名判断
  twoSignState(){
    if(this.data.check_list.state.includes(this.special_first_type)){
      return (this.data.check_list.assigned_to_id == this.userId  && this.data.check_list.state.includes(this.special_first_type))
    }else if(this.data.check_list.state.includes('site agent signed')){
      return (this.data.check_list.assigned_to_last_id == this.userId) && this.data.check_list.state.includes('site agent signed')
    }
  }
  setpSign(){
      const pandStatus = this.data.check_list.state=="Recheck" || this.data.check_list.state=="Contractor Recheck"? 'New' : this.data.check_list.state
      const setpData = this.CurrentData.find((item:any) => {
        return item.CurrentStatus == pandStatus
      })
    if(setpData){
      if(setpData.signNext && setpData.signId){
        return true
      }else{
        return false
      }
    }else{
       return false
    }
    if((this.data.check_list.state.includes('New') || this.data.check_list.state.includes('Recheck'))&&this.firstdocId&&this.data.check_list.created_by_id == this.userId){
      return true
    }else if(this.data.check_list.state.includes(this.special_first_type)&&this.seconddocId&&(this.data.check_list.assigned_to_id == this.userId)){
      return true
    }else if(this.data.check_list.state.includes('site agent signed')&&this.thirddocId&&(this.data.check_list.assigned_to_last_id == this.userId)){
      return true
    } else if(this.data.check_list.state.includes('supervisor checked')&&this.fourthdocId&&(this.data.check_list.fourth_sign_user_id == this.userId)){
      return true
    }else if(this.data.check_list.state.includes('supervisor_1 signed')&&this.fifthdocId&&(this.data.check_list.fifth_sign_user_id == this.userId)){
      return true
    }
    else{
      return false
    }
  }
  showAssign(){
    console.log('this.data.check_list.assigned_to_id',this.setpSign());
    if(this.setpSign()){
      console.log('进不来');

      // Initialize filteredAssignList if not already set
      if (!this.filteredAssignList || this.filteredAssignList.length === 0) {
        this.filteredAssignList = this.checkassightselect
      }

      this.ifCheckAssign = true
    }
    // (data.check_list.executor_id == userId || data.check_list.assigned_to_id == userId ) &&secondSign && ifCheckAssign = true
  }
  clickLi(i:any){
    this.count = 0
    this.num = i
    this.checkYes = 3
    this.allLog = false
    this.hascount =0
    this.dipsle = true
    this.showNum =false
    this.cdRef.detectChanges();
    this.inputInfoId = ''
    jQuery('.CompleteSelectedSection__items-remaining').css({'color':'#819099'});
  }

  clickSign(e:any){
    this.dipsle = false
    this.asideClick(e)
  }
  getStringValue(value:any) {
    return JSON.stringify(value)
  }
  //使用默认签名
  useDefaultSign(e:any){
    if(this.isDefaultSign){
      this.thirddocId = this.currentUser.dataset.sign_doc_id
      this.thirdSign = `${window.location.origin}/api/v3/logical_docs/doc/${
        this.thirddocId
      }/stream`

    }else{
      this.thirddocId = null
      this.thirdSign = null
      }
  }
  ngOnInit() {
    this.jumpUrl = window.location.href
    if(document.documentElement.clientWidth > 770){
        jQuery(".ChecklistPageRightPanel__close-button").css("display","block")
    }

     fromEvent(window,"resize").subscribe((event:any)=>{
       if(document.documentElement.clientWidth>770){
        jQuery(".ChecklistPageRightPanel__close-button").css("display","block")
        jQuery(".content-detailed").css("display","block")
        jQuery(".content-date-left").css("display","block")
        jQuery(".detailShow").css("display","none")
        jQuery(".asideShow").css("display","none")
        jQuery(".asideHide").css("display","none")
       } else {
        jQuery(".ChecklistPageRightPanel__close-button").css("display","none")
       }
     })

    if(window.location.href.indexOf('check_listsID')<0){
      let url =window.location.href.split('?')[0]
      let newUrl = url+'?kind_id='+this.kind_id+'&check_listsID='+this.check_listsID
      window.history.replaceState(null, '', newUrl)
    }

    jQuery('#content-wrapper').css({'background':'#ecf0f3','padding': 0});

    this.projectId = document.querySelector('meta[name=current_project]')
    this.id = this.projectId.dataset.projectId
    if(this.kind_id== 2 || this.kind_id == 3){
        this.CurrentData = this.dcData
    }else if(this.kind_id== 4){
      this.special_first_type = 'environmental officer signed'
      this.CurrentData = this.envData
    }else if(this.kind_id== 6){
      this.CurrentData = this.monData
    }else {
      this.CurrentData = this.safetyData
        this.special_first_type = 'safety officer signed'
    }
    this.getInfo()

    // this.service.work_packages(this.id,{}).subscribe((res:any)=>{
    //   //console.log(res,'baocuo')
    //   let dateitem = res._embedded.schema.type._links.allowedValues.find((res:any)=>res.title == 'Task')
    //   //console.log(dateitem.href);
    //   this.service.work_packages(this.id,{_links:{type:{href:dateitem.href}}}).subscribe((data:any)=>{
    //     //console.log()
    //     this.payload = data._embedded.payload
    //     this.schema = data._embedded.schema
    //   })

    // })




    this.service.getbyUserList(this.id,).subscribe((res:any)=>{
      this.byuserdata = res._embedded.elements
    })

    this.service.getLocations(this.kind_id).subscribe((res: any) => {
      this.locationsData = res
      this.cdRef.detectChanges();
    })
    if(this.currentUser.dataset.sign_doc_id){
      this.isShowDefaultSign = true
    }
  }
  dataURLtoBlob(dataurl:any) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }
  handleClick() {
    let Itemuser = null
    if(this.data.check_list.state.includes('Completed')) {
      Itemuser = this.data.check_list.assigned_to_last_group.find( (item:any) => {
        return item.id == Number(this.userId)
      })
    } else {
      Itemuser = this.data.check_list.assigned_to_group.find( (item:any) => {
        return item.id == Number(this.userId)
      })
    }

    //console.log(!!Itemuser)
    if(!!Itemuser) {
      //console.log(Itemuser, !this.isHandle())
      if(!this.isHandle()) {
        let data = {

        }
        if(this.data.check_list.state.includes('Sent')) {
          data = {
            executor_id: Number(this.userId)
          }
          this.service.saveChecklist(Number(this.check_listsID), data).subscribe( () => {
            this.data.check_list.executor_id = Number(this.userId)
            this.data.check_list.executor = this.data.check_list.assigned_to_group.find( (item:any) => {
              return this.data.check_list.executor_id == item.id
            })
          }, (err:any) => {
            alert('Handler already exists')
          }
          )
        } else {
          data = {
            executor_last_id: Number(this.userId)
          }
          this.service.saveChecklist(Number(this.check_listsID), data).subscribe( () => {
            this.data.check_list.executor_last_id = Number(this.userId)
            this.data.check_list.executor_last = this.data.check_list.assigned_to_last_group.find( (item:any) => {
              return this.data.check_list.executor_last_id == item.id
            })
          },
           (err:any) => {
            alert('Handler already exists')
          })
        }

      } else {
        //console.log(this.data.check_list.executor_id== Number(this.userId), this.data.check_list.executor_last_id== Number(this.userId))
        if(this.data.check_list.executor_id== Number(this.userId) ) {
          this.service.saveChecklist(Number(this.check_listsID), {
            executor_id: null
          }).subscribe( () => {
            this.data.check_list.executor_id = null
            this.data.check_list.executor = null
          }, (err:any) => {
            alert('Handler already exists')
          })
        }
        if(this.data.check_list.executor_last_id== Number(this.userId)) {

          this.service.saveChecklist(Number(this.check_listsID), {
            executor_last_id: null
          }).subscribe( () => {
            this.data.check_list.executor_last_id = null
            //console.log(this.data.check_list.executor_last_id)
            this.data.check_list.executor_last = null
          }, (err:any) => {
            alert('Handler already exists')
          })
        }


      }
    }
  }
  showSignBox(num:any){
    const safetyMap:any = {
      'Recheck':0,
      'new':1,
      'Assistant Safety Officer Signed':2,
      'Safety Officer Signed':3,
      'Site Agent Signed':4,
      'Project Manager Signed':5,
      'Assistant Safety Officer Second Signed':6,
      'Safety Officer Second Signed':7,
      'Site Agent Second Signed':8,
      'Project Manager Second Signed':9,
    }
    const dcMap:any={
      'Contractor Recheck':0,
      'new':1,
      'Contractor Sent':2,
      "Engineer's Representative Signed":3,
      'Closed':4,
    }

    const envMap:any = {
      'Recheck':0,
      'new':1,
      'Sent':2,
      "Contractor's Signed":3,
      'Closed':4,
    }
    const monMap:any = {
      'Recheck':0,
      'new':1,
      'Contractor SO Signed':2,
      'Closed':4,
    }
    let statusMap:any = {}
    if(this.kind_id == 7){
      statusMap = safetyMap
    } else if(this.kind_id == 2 || this.kind_id == 3){
      statusMap = dcMap
    } else if(this.kind_id == 4){
      statusMap = envMap
    }else if(this.kind_id == 6){
      statusMap = monMap
    }
    if(num == 2){
        return( this.data.check_list.reply&& !statusMap[this.data.check_list.state])  ||  statusMap[this.data.check_list.state]>1
    }else if (num == 3){
      return (this.data.check_list.reply_last&&!statusMap[this.data.check_list.state])  ||statusMap[this.data.check_list.state]>2
    }else if (num == 4){
      return (this.data.check_list.fourth_sign_remark&&!statusMap[this.data.check_list.state])  ||  statusMap[this.data.check_list.state]>3
    }else if (num == 5){
      return (this.data.check_list.fifth_sign_remark&&!statusMap[this.data.check_list.state])  ||statusMap[this.data.check_list.state]>4
    }else if (num == 6){
      return (this.data.check_list.sixth_sign_remark&&!statusMap[this.data.check_list.state])  ||statusMap[this.data.check_list.state]>5
    }else if (num == 7){
      return (this.data.check_list.seventh_sign_remark&&!statusMap[this.data.check_list.state])  ||statusMap[this.data.check_list.state]>6
    }else if (num == 8){
      return (this.data.check_list.eighth_sign_remark&&!statusMap[this.data.check_list.state])  ||statusMap[this.data.check_list.state]>7
    }else{
      return false
    }
  }
  checkDisable():boolean {
      if((this.data.check_list.state.includes('New') || this.data.check_list.state.includes('Recheck'))){
        return false
      }else{
       return true
      }
  }
  isHandle() {

    if(this.data.check_list.state.includes('Sent')) {
      return this.data.check_list.executor_id == this.userId
    } else {
      return this.data.check_list.executor_last_id == this.userId
    }
  }
  canClickHandle() {
    if(this.data.check_list.state.includes('Sent')) {
        if(!this.data.check_list.assigned_to_group) {
          return
        }
      return this.isHandle() || (!!this.data.check_list.assigned_to_group.find( (item:any) => {
        return item.id == Number(this.userId)
      }) && !this.data.check_list.executor_id)
    } else {
      if(!this.data.check_list.assigned_to_last_group) {
        return
      }
      return this.isHandle() || (!!this.data.check_list.assigned_to_last_group.find( (item:any) => {
        return item.id == Number(this.userId)
      }) && !this.data.check_list.executor_last_id)
    }
  }
  AssignSave(state?:any, isSave?: any) {
    const pandStatus = this.data.check_list.state=="Recheck" || this.data.check_list.state=="Contractor Recheck"? 'New' : this.data.check_list.state
    const newData = this.CurrentData.find((item:any) => {
      return item.CurrentStatus == pandStatus
    })
    if(!newData.disabled || !newData.signNext){
      return
    }
    let recheck = ''
    let  data  = {} as any
      if(isSave){
        data.state = newData.CurrentStatus
      }else{
        data.state = newData.NextStatus
      }
    console.log(this.constructorUserId,newData,'jabcdd');
    if(this.constructorUserId) {
        data[newData.nextId] = Number(this.constructorUserId)
    } else if( !isSave  && state !== 'Recheck' && state !== 'Contractor Recheck' && newData.NextStatus!== this.CurrentData[this.CurrentData.length - 1].CurrentStatus){
      console.log(isSave,state,!!newData.NextStatus,'jabcddc');
      return
    }
    if(state == 'Recheck') {
      if(this.data.check_list.state == this.CurrentData[1].CurrentStatus) {
       recheck = 'recheck'
      }else{
        recheck = 'recheck_two'
       }
      this.assigntLoading = true
      this.service.setRecheck(this.check_listsID, recheck).subscribe( () => {
        this.assigntLoading = false
      }, () => {
        this.assigntLoading = false
      })
    } else {

      data.recheck = ''
    }
    console.log(data,'data');
    this.checkListSave(data, state, isSave)
  }


  clickassign() {
    //console.log(!this.secondSign , this.data.check_list.executor_id != this.userId , this.data.check_list.assigned_to_id != this.userId )
  }
  changeAssignTo(type:any) {
    this.assignType = type
    this.searchKeyword = ''

    if(type == 'Indlvidual') {

      this.checkassightselect = this.userData
    } else {
      this.checkassightselect = this.groupData
    }

    // Initialize filtered list
    this.filteredAssignList = this.checkassightselect
  }

  filterAssignList() {
    if (!this.searchKeyword || this.searchKeyword.trim() === '') {
      this.filteredAssignList = this.checkassightselect
      return
    }

    const keyword = this.searchKeyword.toLowerCase().trim()

    this.filteredAssignList = this.checkassightselect.filter((item: any) => {
      const name = item.name || (item.firstname + item.lastname) || ''
      const position = item.position || ''

      return name.toLowerCase().includes(keyword) ||
             position.toLowerCase().includes(keyword)
    })
  }

  checkListSave(data:any, state:any, isSave?:any) {
    //console.log(data)
    let cc_ids = this.userData.filter( (item:any) => {
      return item.checked
    }).map( (item:any) => {
      return item.id
    }).concat(
      this.groupData.filter( (item:any) => {
        return item.checked
      }).map( (item:any) => {
        return item.id
      })
    )
    const dataIndex = this.CurrentData.findIndex((item:any) => {
      return item.CurrentStatus == this.data.check_list.state
    })
    const sumbmitArr = this.CurrentData.slice(0,8)
    // const sumbmitArr = this.CurrentData

    console.log(sumbmitArr,'dataIndex');
    let   sign ={} as any
    //console.log(state == 'Recheck')
    if(state == 'Recheck' || state == 'Contractor Recheck') {
      sumbmitArr.forEach((item:any) => {
        sign[item.requiredType] = item.remark
      })
      // sign = {
      //   action_required: this.data.check_list.action_required,
      //   reply: this.data.check_list.reply,
      //   reply_last: this.data.check_list.reply_last,
      //   fourth_sign_remark:this.data.check_list.fourth_sign_remark,
      //   fifth_sign_remark:this.data.check_list.fifth_sign_remark,
      // } as any
    } else {
       sumbmitArr.forEach((item:any) => {
        sign[item.requiredType] = item.remark
        sign[item.timeType] = item.dateTime
        sign[item.signType] = item.signId
        console.log(item,'item',sign);

      })
      // sign = {
      //   created_doc_id: this.firstdocId,
      //   assigned_doc_id: this.seconddocId,
      //   action_required: this.data.check_list.action_required,
      //   reply: this.data.check_list.reply,
      //   reply_last: this.data.check_list.reply_last,
      //   assigned_doc_last_id: this.thirddocId,
      //   fourth_sign_doc_id:this.fourthdocId,
      //   fifth_sign_doc_id:this.fifthdocId,
      //   fourth_sign_remark:this.data.check_list.fourth_sign_remark,
      //   fifth_sign_remark:this.data.check_list.fifth_sign_remark,
      //   fourth_sign_at:this.data.check_list.fourth_sign_at,
      //   fifth_sign_at:this.data.check_list.fifth_sign_at,
      //   submission_sign_at: this.data.check_list.submission_sign_at,
      //   inspection_first_sign_at:this.data.check_list.inspection_first_sign_at,
      //   inspection_second_sign_at:this.data.check_list.inspection_second_sign_at
      // } as any
    }
    console.log(sign,data,'sign');
    if(cc_ids.length > 0) {
        data.cc_ids = cc_ids
    }
    this.assigntLoading = true

    this.service.update_sign(Number(this.check_listsID), {
      sign
    }).subscribe( () => {
      if(state == 'Recheck' || state == 'Contractor Recheck' || isSave) {
        this.ifCheckAssign = false
        this.assigntLoading = false
        this.cleon()
      } else {

        this.service.saveChecklist(Number(this.check_listsID), data).subscribe( () => {
          this.ifCheckAssign = false
          this.assigntLoading = false
          this.cleon()
        },
        () => {
          this.assigntLoading = false
        })
      }
    })
  }
  closeView(img:any){
    if(img){
      if(this.isSignBoxItem){
        let blob = this.dataURLtoBlob(img)
        var files = new File([blob], 'drawComplete.png', { type: blob.type })
        let file = new FormData();
        file.append('file', files);
        file.append('prefix', 'risc');
        this.signloding = true
        this.service.postSign(file).subscribe( (res:any)=> {
          const data = {sign_id:res.doc_id,...this.sign_box}
          this.updateInfo(data)
          this.signloding = false
        })
      }else{

        let blob = this.dataURLtoBlob(img)
        var files = new File([blob], 'drawComplete.png', { type: blob.type })
        let file = new FormData();
        file.append('file', files);
        file.append('prefix', 'risc');
        this.CurrentData[this.signType].signloding = true
        this.service.postSign(file).subscribe( (res:any)=> {
          //console.log(res)
          this.firstdocId = res.doc_id
          this.CurrentData[this.signType].signId = res.doc_id
          this.CurrentData[this.signType].img = img
          this.CurrentData[this.signType].signloding = false
          console.log(this.CurrentData);

          this.firstSign = img
        })
      }
      //  else if(this.signType == 'second'){

      //   let blob = this.dataURLtoBlob(img)
      //   var files = new File([blob], 'drawComplete.png', { type: blob.type })
      //   let file = new FormData();
      //   file.append('file', files);
      //   file.append('prefix', 'risc');
      //   this.reSignLoad = true
      //   this.service.postSign(file).subscribe( (res:any)=> {
      //     //console.log(res)
      //     this.seconddocId = res.doc_id
      //     this.reSignLoad = false
      //     this.secondSign = img
      //   })
      // } else if (this.signType == 'third') {
      //   let blob = this.dataURLtoBlob(img)
      //   var files = new File([blob], 'drawComplete.png', { type: blob.type })
      //   let file = new FormData();
      //   file.append('file', files);
      //   file.append('prefix', 'risc');
      //   this.assigned_doc_last_loading = true
      //   this.service.postSign(file).subscribe( (res:any)=> {
      //     //console.log(res)
      //     this.thirddocId = res.doc_id
      //     this.assigned_doc_last_loading = false
      //     this.thirdSign = img
      //   })
      // }else if (this.signType == 'fourth') {
      //   let blob = this.dataURLtoBlob(img)
      //   var files = new File([blob], 'drawComplete.png', { type: blob.type })
      //   let file = new FormData();
      //   file.append('file', files);
      //   file.append('prefix', 'risc');
      //   this.reSignLoad = true
      //   this.service.postSign(file).subscribe( (res:any)=> {
      //     //console.log(res)
      //     this.fourthdocId = res.doc_id
      //     this.reSignLoad = false
      //     this.fourthSign = img
      //   })
      // }else if (this.signType == 'fifth') {
      //   let blob = this.dataURLtoBlob(img)
      //   var files = new File([blob], 'drawComplete.png', { type: blob.type })
      //   let file = new FormData();
      //   file.append('file', files);
      //   file.append('prefix', 'risc');
      //   this.reSignLoad = true
      //   this.service.postSign(file).subscribe( (res:any)=> {
      //     //console.log(res)
      //     this.fifthdocId = res.doc_id
      //     this.reSignLoad = false
      //     this.fifthSign = img
      //   })
      // }
    }
    this.isSignBoxItem = false
    this.dipslesignature = false
    //console.log(img)
  }

  downloadPdf(){
    this.showPdfdownload = false
  }
  deletesecondSign() {
    this.secondSign = null
    this.seconddocId = null
  }
  deleteSssignedLast() {
    this.thirddocId = null
    this.thirdSign = null
    this.isDefaultSign = false
  }
  deletefirstSign(type:any) {
    let that = this as any
    that[type+ 'Sign'] = null
    that[type + 'docId'] = null
  }
  deleteSecodSign() {
    this.secondSign = null
    this.seconddocId = null
  }
  deleteSign(index:any){
    console.log(index,'deleteSign');

    this.CurrentData[index].signId = null
    this.CurrentData[index].img = null
  }
  backstep(){

    this.showPdfdownload =true
  }

  getCount(e:any){
    let count:number = 0
    for(let item of e){
      if(item.list){
        count +=item.list.length
      }
    }
    return count
  }
  removeDownLoadIframe() {

    if(this.aImage && this.fill_env && this.choice_env){
      document.body.removeChild(this.aImage)
      document.body.removeChild(this.fill_env)
      document.body.removeChild(this.choice_env)
    }
  }
  getHrefDownloadPdf(){
    this.removeDownLoadIframe()
      if(this.kind_id == 2){
      this.aImage = document.createElement('iframe')
      this.aImage.src = `/projects/${this.id}/check_lists/export_inspection_pdf/${this.check_listsID}/daily_cleansing`
      this.aImage.style.display = 'none'
      document.body.appendChild(this.aImage)
    }else if(this.kind_id == 3){
      this.aImage = document.createElement('iframe')
      this.aImage.src = `/projects/${this.id}/check_lists/export_inspection_pdf/${this.check_listsID}/weekly_tidying`
      this.aImage.style.display = 'none'
      document.body.appendChild(this.aImage)
    }else if(this.kind_id == 7){
        this.aImage = document.createElement('iframe')
        this.aImage.src = `/projects/${this.id}/check_lists/export_inspection_pdf/${this.check_listsID}/image_safety`
        this.aImage.style.display = 'none'
        document.body.appendChild(this.aImage)
        this.fill_env = document.createElement('iframe')
        this.fill_env.src = `/projects/${this.id}/check_lists/export_inspection_pdf/${this.check_listsID}/fill_safety`
        this.fill_env.style.display = 'none'
        document.body.appendChild(this.fill_env)
        this.choice_env = document.createElement('iframe')
        this.choice_env.src = `/projects/${this.id}/check_lists/export_inspection_pdf/${this.check_listsID}/choice_safety`
        this.choice_env.style.display = 'none'
        document.body.appendChild(this.choice_env)
    }else{
      this.aImage = document.createElement('iframe')
      this.aImage.src = `/projects/${this.id}/check_lists/export_inspection_pdf/${this.check_listsID}/image_env`
      this.aImage.style.display = 'none'
      document.body.appendChild(this.aImage)
      this.fill_env = document.createElement('iframe')
      this.fill_env.src = `/projects/${this.id}/check_lists/export_inspection_pdf/${this.check_listsID}/fill_env`
      this.fill_env.style.display = 'none'
      document.body.appendChild(this.fill_env)
      this.choice_env = document.createElement('iframe')
      this.choice_env.src = `/projects/${this.id}/check_lists/export_inspection_pdf/${this.check_listsID}/choice_env`
      this.choice_env.style.display = 'none'
      document.body.appendChild(this.choice_env)
    }

  }

  getHref(){
    if(this.kind_id == 4){
      return `/projects/${this.id}/check_lists/export_inspection_pdf/${this.check_listsID}/weekly_env`
    }else if(this.kind_id == 7){
      return `/projects/${this.id}/check_lists/export_inspection_pdf/${this.check_listsID}/weekly_safety`
    }else{
      return `/projects/${this.id}/check_lists/export_pdf/${this.check_listsID}`
    }
    // return `/projects/${this.id}/check_lists/${this.check_listsID}/export`
  }



  getInfo(){
    return new Promise((resolve,reject)=>{
      this.service.getCheckList(this.id,this.check_listsID).subscribe((res: any) => {
        this.signBy = res.check_list.check_list_metum.signs
        if(res.result == 'ok'){
          this.saveRes =res.check_list
          // this.data = res
          if(!this.inputInfoId){
            this.data = res
            let role = ''
              if(this.data.check_list.state == 'New' || this.data.check_list.state == 'Recheck' || this.data.check_list.state == 'Contractor Recheck') {
                role = 'Contractor'
              } else {
                role = 'Consultant'
              }
            this.service.getsignUserList(this.id, this.kind_id).subscribe((res: any) => {
              this.userData = res
              this.checkassightselect = this.userData
              this.filteredAssignList = this.userData
              this.cdRef.detectChanges();
            })
            this.service.getGroupList(this.id, this.kind_id).subscribe((res: any) => {
              this.groupData = res
              this.cdRef.detectChanges();
            })
            this.firstdocId = this.saveRes.created_doc_id
            this.seconddocId = this.saveRes.assigned_doc_id
            this.thirddocId = this.saveRes.assigned_doc_last_id
            this.fourthdocId = this.saveRes.fourth_sign_doc_id
            this.fifthdocId = this.saveRes.fifth_sign_doc_id
            this.CurrentData.map((item:any,index:any) => {
              console.log(index,item);
              if(item.NextStatus){
                if(index == 0){
                  item.img =res.check_list.created_doc_id? location.origin + `/api/v3/logical_docs/doc/${res.check_list.created_doc_id}/stream`:''
                  item.userName = res.check_list.created_by_user + '(' + res.check_list.created_by_position + ')'
                  item.remark = res.check_list.action_required
                  item.requiredType = 'action_required'
                  item.dateTime = res.check_list.submission_sign_at
                  item.isShowBox = true
                  item.signNext = res.check_list.created_by_id == this.userId
                  item.timeType = 'submission_sign_at'
                  item.signId = res.check_list.created_doc_id
                  item.nextId = 'assigned_to_id'
                  item.signType = 'created_doc_id'
                  item.disabled=(item.CurrentStatus == res.check_list.state || res.check_list.state =='Recheck' || res.check_list.state =='Contractor Recheck' ) && res.check_list.created_by_id == this.userId
                  item.isDefaultSign = this.defaultDoc && (item.CurrentStatus == res.check_list.state || res.check_list.state =='Recheck' || res.check_list.state =='Contractor Recheck') && res.check_list.created_by_id == this.userId
                } else if (index == 1){
                  item.img =res.check_list.assigned_doc_id? location.origin + `/api/v3/logical_docs/doc/${res.check_list.assigned_doc_id}/stream`:''
                  item.userName = res.check_list.assigned_to? res.check_list.assigned_to.firstname+' '+res.check_list.assigned_to.lastname + '(' + res.check_list.assigned_to.position + ')' : ''
                  item.remark = res.check_list.reply
                  item.requiredType = 'reply'
                  item.dateTime = res.check_list.assigned_sign_at
                  item.isShowBox = this.showSignBox(index+1)
                  item.signNext = res.check_list.assigned_to_id == this.userId
                  item.timeType = 'assigned_sign_at'
                  item.signId = res.check_list.assigned_doc_id
                  item.nextId = 'assigned_to_last_id'
                  item.signType = 'assigned_doc_id'
                  item.disabled=item.CurrentStatus == res.check_list.state && res.check_list.assigned_to_id == this.userId
                  item.isDefaultSign = this.defaultDoc && item.CurrentStatus == res.check_list.state && res.check_list.assigned_to_id == this.userId
                }else if (index == 2){
                  item.img =res.check_list.assigned_doc_last_id? location.origin + `/api/v3/logical_docs/doc/${res.check_list.assigned_doc_last_id}/stream`:''
                  item.userName = res.check_list.assigned_to_last? res.check_list.assigned_to_last.firstname+' '+res.check_list.assigned_to_last.lastname + '(' + res.check_list.assigned_to_last.position + ')' : ''
                  item.remark = res.check_list.reply_last
                  item.requiredType = 'reply_last'
                  item.dateTime = res.check_list.assigned_sign_last_at
                  item.isShowBox = this.showSignBox(index+1)
                  item.signNext = res.check_list.assigned_to_last_id == this.userId
                  item.timeType = 'assigned_sign_last_at'
                  item.signId = res.check_list.assigned_doc_last_id
                  item.nextId = 'fourth_sign_user_id'
                  item.signType = 'assigned_doc_last_id'
                  item.disabled=item.CurrentStatus == res.check_list.state && res.check_list.assigned_to_last_id == this.userId
                  item.isDefaultSign = this.defaultDoc && item.CurrentStatus == res.check_list.state && res.check_list.assigned_to_last_id == this.userId
                }else if (index == 3){
                  item.img =res.check_list.fourth_sign_doc_id? location.origin + `/api/v3/logical_docs/doc/${res.check_list.fourth_sign_doc_id}/stream`:''
                  item.userName = res.check_list.fourth_sign_user? res.check_list.fourth_sign_user.firstname+' '+res.check_list.fourth_sign_user.lastname + '(' + res.check_list.fourth_sign_user.position + ')' : ''
                  item.remark = res.check_list.fourth_sign_remark
                  item.requiredType = 'fourth_sign_remark'
                  item.dateTime = res.check_list.fourth_sign_at
                  item.isShowBox = this.showSignBox(index+1)
                  item.signNext = res.check_list.fourth_sign_user_id == this.userId
                  item.timeType = 'fourth_sign_at'
                  item.signId = res.check_list.fourth_sign_doc_id
                  item.nextId = 'fifth_sign_user_id'
                  item.signType = 'fourth_sign_doc_id'
                  item.disabled=item.CurrentStatus == res.check_list.state && res.check_list.fourth_sign_user_id == this.userId
                  item.isDefaultSign = this.defaultDoc && item.CurrentStatus == res.check_list.state && res.check_list.fourth_sign_user_id == this.userId
                }else if (index == 4){
                  item.img =res.check_list.fifth_sign_doc_id? location.origin + `/api/v3/logical_docs/doc/${res.check_list.fifth_sign_doc_id}/stream`:''
                  item.userName = res.check_list.fifth_sign_user? res.check_list.fifth_sign_user.firstname+' '+res.check_list.fifth_sign_user.lastname + '(' + res.check_list.fifth_sign_user.position + ')' : ''
                  item.remark = res.check_list.fifth_sign_remark
                  item.requiredType = 'fifth_sign_remark'
                  item.dateTime = res.check_list.fifth_sign_at
                  item.isShowBox = this.showSignBox(index+1)
                  item.signNext = res.check_list.fifth_sign_user_id == this.userId
                  item.timeType = 'fifth_sign_at'
                  item.signId = res.check_list.fifth_sign_doc_id
                  item.nextId = 'sixth_sign_user_id'
                  item.signType = 'fifth_sign_doc_id'
                  item.disabled=item.CurrentStatus == res.check_list.state && res.check_list.fifth_sign_user_id == this.userId
                  item.isDefaultSign = this.defaultDoc && item.CurrentStatus == res.check_list.state && res.check_list.fifth_sign_user_id == this.userId
                }else if (index == 5){
                  item.img =res.check_list.sixth_sign_doc_id? location.origin + `/api/v3/logical_docs/doc/${res.check_list.sixth_sign_doc_id}/stream`:''
                  item.userName = res.check_list.sixth_sign_user? res.check_list.sixth_sign_user.firstname+' '+res.check_list.sixth_sign_user.lastname + '(' + res.check_list.sixth_sign_user.position + ')' : ''
                  item.remark = res.check_list.sixth_sign_remark
                  item.requiredType = 'sixth_sign_remark'
                  item.dateTime = res.check_list.sixth_sign_at
                  item.isShowBox = this.showSignBox(index+1)
                  item.signNext = res.check_list.sixth_sign_user_id == this.userId
                  item.timeType = 'sixth_sign_at'
                  item.signId = res.check_list.sixth_sign_doc_id
                  item.nextId = 'seventh_sign_user_id'
                  item.signType = 'sixth_sign_doc_id'
                  item.disabled=item.CurrentStatus == res.check_list.state && res.check_list.sixth_sign_user_id == this.userId
                  item.isDefaultSign = this.defaultDoc && item.CurrentStatus == res.check_list.state && res.check_list.sixth_sign_user_id == this.userId
                }else if (index == 6){
                  item.img =res.check_list.seventh_sign_doc_id? location.origin + `/api/v3/logical_docs/doc/${res.check_list.seventh_sign_doc_id}/stream`:''
                  item.userName = res.check_list.seventh_sign_user? res.check_list.seventh_sign_user.firstname+' '+res.check_list.seventh_sign_user.lastname + '(' + res.check_list.seventh_sign_user.position + ')' : ''
                  item.remark = res.check_list.seventh_sign_remark
                  item.requiredType = 'seventh_sign_remark'
                  item.dateTime = res.check_list.seventh_sign_at
                  item.isShowBox = this.showSignBox(index+1)
                  item.signNext = res.check_list.seventh_sign_user_id == this.userId
                  item.timeType = 'seventh_sign_at'
                  item.signId = res.check_list.seventh_sign_doc_id
                  item.nextId = 'eighth_sign_user_id'
                  item.signType = 'seventh_sign_doc_id'
                  item.disabled=item.CurrentStatus == res.check_list.state && res.check_list.seventh_sign_user_id == this.userId
                  item.isDefaultSign = this.defaultDoc && item.CurrentStatus == res.check_list.state && res.check_list.seventh_sign_user_id == this.userId
                }else if (index == 7){
                  item.img =res.check_list.eighth_sign_doc_id? location.origin + `/api/v3/logical_docs/doc/${res.check_list.eighth_sign_doc_id}/stream`:''
                  item.userName = res.check_list.eighth_sign_user? res.check_list.eighth_sign_user.firstname+' '+res.check_list.eighth_sign_user.lastname + '(' + res.check_list.eighth_sign_user.position + ')' : ''
                  item.remark = res.check_list.eighth_sign_remark
                  item.requiredType = 'eighth_sign_remark'
                  item.dateTime = res.check_list.eighth_sign_at
                  item.isShowBox = this.showSignBox(index+1)
                  item.signNext = res.check_list.eighth_sign_user_id == this.userId
                  item.timeType = 'eighth_sign_at'
                  item.signId = res.check_list.eighth_sign_doc_id
                  item.nextId = ''
                  item.signType = 'eighth_sign_doc_id'
                  item.disabled=item.CurrentStatus == res.check_list.state && res.check_list.eighth_sign_user_id == this.userId
                  item.isDefaultSign = this.defaultDoc && item.CurrentStatus == res.check_list.state && res.check_list.eighth_sign_user_id == this.userId
                }
              }
            })

            if(this.firstdocId){
              this.firstSign =  this.firstSign = location.origin + `/api/v3/logical_docs/doc/${this.firstdocId}/stream`
            }
            if(this.seconddocId) {
              this.secondSign = location.origin + `/api/v3/logical_docs/doc/${this.seconddocId}/stream`
            }
            if(this.thirddocId) {
              this.thirdSign = location.origin + `/api/v3/logical_docs/doc/${this.thirddocId}/stream`
            }
            if(this.fourthdocId) {
              this.fourthSign = location.origin + `/api/v3/logical_docs/doc/${this.fourthdocId}/stream`
            }
            if(this.fifthdocId) {
              this.fifthSign = location.origin + `/api/v3/logical_docs/doc/${this.fifthdocId}/stream`
            }
            if(this.data.check_list.file_ref_no){
              this.saveFileFlag = false
            }
          }
          this.inputInfoId = ''
          this.getFileRefNoInfo();
          this.sum = 0
          this.sum_num = 0
          this.utils.updateRadioOptions( this.data.check_list.check_list_metum.parts, 'all')
          for(let i of this.data.check_list.check_list_metum.parts){
            let arr:any=[]
            for(let item of i.items){
              for(let subitem of item.list){
                this.sum_num+=1
                if(subitem.value!==''&&subitem.value!==null){
                  arr.push(subitem)
                }
              }
            }
            i.count = arr.length
            this.sum+=i.count
            this.cdRef.detectChanges();
          }

          this.arr_sum = this.data.check_list.check_list_metum.parts.filter((j:any)=>{
            return j.state == 'finished'
          })

          this.assigned_to_id = this.data.check_list.created_by_id
          this.check_list_location_id = this.data.check_list.check_list_location_id
          this.expected_finish_at = this.data.check_list.expected_finish_at

          this.count_doc = this.data.check_list.check_list_metum.signs.filter((i:any)=>{
            return i.doc_id !== ''
          })


          if(this.i18n.locale == 'en'){
            this.detailsbottomtext =  `last updated by ${res.check_list.updated_by_user} on ${res.check_list.updated_at}`
          }else if(this.i18n.locale == 'zh-CN' || this.i18n.locale == 'zh-TW'){
            this.detailsbottomtext = `由 ${res.check_list.updated_by_user} 于 ${res.check_list.updated_at} 最后更新`
          }


          this.show_banner =   this.arr_sum.length === this.data.check_list.check_list_metum.parts.length &&
          this.data.check_list.state !== 'finished' &&
          this.count_doc.length === this.data.check_list.check_list_metum.signs.length



          // if(!this.inputInfoId) return
          // setTimeout(()=>{
          //   jQuery(`#${this.inputInfoId}`).select()
          //   jQuery(`#${this.inputInfoId}`).hide()
          //   this.inputInfoId = ""
          // },1000)
          }
          resolve(true)
      })
   })
  }

  showTime(time:any){
    laydate.render({
      elem: '#checklostsdate',
      type:'date',
      value:time,
      show:true,
      done:(value:any)=>{
        if(!value){
          this.expected_finish_at = null
          jQuery('#checklostsdate').text('未指定')
        }else{
          this.expected_finish_at = value
        }
        this.updateUserCheckList({expected_finish_at:this.expected_finish_at})
      }
    });
  }
  defaultCheck(type:any, e:any){
    console.log(type,e)
    let that = this as any
    if( e.target.checked == false) {
        this.CurrentData[type].signId = null
        this.CurrentData[type].img = null
        // that[type+ 'Sign'] = null
        // that[type + 'docId'] = null
    } else {
      if(this.defaultDoc) {
         this.CurrentData[type].signId = this.defaultDoc
        this.CurrentData[type].img = location.origin + `/api/v3/logical_docs/doc/${this.defaultDoc}/stream`
        //console.log(that[type+ 'Sign'], type+ 'Sign')
      }
    }

  }
  check(value:any) {
    if(value == 3){
      return
    }
    let httpArray:any = []
    this.data.check_list.check_list_metum.parts[this.num].items.forEach( (item:any, index:number) => {
      item.list.forEach((el:any, sub:any) => {
        if(el.type === 'radio') {
          el.value = value
          let data={
            value,
            part:this.num,
            item:index,
            sub_item:sub
          }
          let http = this.service.updateItem({
            p_id:this.id,
            c_id:this.check_listsID,
            data:data
          })
          httpArray.push(http)
        }
      });
    })
    this.checkSome(httpArray)
    // forkJoin(httpArray).subscribe ( (res:any) => {
    //     this.getInfo()
    //   if(this.data.check_list.state == 'pending'){
    //     this.data.check_list.state = 'processing'
    //     this.service.updateCheckListstate({
    //       p_id:this.id,
    //       c_id:this.check_listsID,
    //       data:{state:'processing'}
    //     }).subscribe((res:any)=>{
    //     })
    //   }
    //   jQuery('.CompleteSelectedSection__items-remaining').css({'color':'#819099'});
    // })
  }
  checkSome(httpArray: Array<any>):any {

    httpArray.shift().subscribe((res:any):any => {
     if(httpArray.length > 0) {
       this.checkSome(httpArray)
     } else {
      this.getInfo()
        if(this.data.check_list.state == 'pending'){
          this.data.check_list.state = 'processing'
          this.service.updateCheckListstate({
            p_id:this.id,
            c_id:this.check_listsID,
            data:{state:'processing'}
          }).subscribe((res:any)=>{
          })
        }
     }
    })


  }
  updateInfo(datas:any){
    this.showNum = false
    let data=datas
    // 保存content-date-conter的滚动位置
    const contentDateCounter = document.querySelector('.content-date-conter');
    const scrollPosition = contentDateCounter ? contentDateCounter.scrollTop : 0;
    this.service.updateItem({
      p_id:this.id,
      c_id:this.check_listsID,
      data:data
    }).subscribe((res: any) => {
      this.getInfo().then((res:any)=>{
        if(contentDateCounter) {
          contentDateCounter.scrollTop = scrollPosition;
        }
      })
      if(this.data.check_list.state == 'pending'){
        this.data.check_list.state = 'processing'
        this.service.updateCheckListstate({
          p_id:this.id,
          c_id:this.check_listsID,
          data:{state:'processing'}
        }).subscribe((res:any)=>{
          this.sign_box.sub_item = null
          this.sign_box.part = null
          this.sign_box.item = null
        })
      }
      jQuery('.CompleteSelectedSection__items-remaining').css({'color':'#819099'});
    },
    error=>{
    alert(error.error.errors)
    })
  }


  updateUserInfo(event:any,i:any,sub:any){
    let data={
      value:event.target.value,
      part:this.num,
      item:i,
      sub_item:sub
    }

      this.updateInfo(data)
      // if(!this.inputInfoId) return
      // setTimeout(()=>{
      //   jQuery(`#${this.inputInfoId}`).select()
      //   this.inputInfoId = ""
      // },1000)
  }
  input_getinfoInputChange(i:any,sub:any){
    this.inputInfoId = `input_getinfo${i}${sub}`

  }

  changeSelect(event:any,j:any,i:any,sub:any){
    let data={
      value:j,
      part:this.num,
      item:i,
      sub_item:sub
    }
    this.checkYes = 3
    this.updateInfo(data)
  }
  changeCheckbox(val:any,j:any,i:any,sub:any,subitem:any){
    let arrayIndex = []

    for(let item of val.target.parentNode.parentNode.children ) {
      let targetValue =  Number(item.childNodes[0].value)
      if(item.childNodes[0].checked == true&&arrayIndex.indexOf(targetValue)==-1){
        arrayIndex.push(targetValue)
      }
      // else if (item.childNodes[0].checked == false&&arrayIndex.indexOf(targetValue)>=0){
      //   let i =arrayIndex.indexOf(targetValue)
      //   arrayIndex.splice(i,1)
      // }
    }

    // if(val.target.checked == true&&arrayIndex.indexOf(j)==-1){
    //   arrayIndex.push(Number(j))
    // }else if (val.target.checked == false&&arrayIndex.indexOf(Number(j))>=0){
    //   let i =arrayIndex.indexOf(Number(j))
    //   arrayIndex.splice(i,1)
    // }
    let data={
      value:arrayIndex,
      part:this.num,
      item:i,
      sub_item:sub
    }
    this.updateInfo(data)
  }

  period_endChange(e:any,i:any,sub:any,subitem:any) {
   let ruler1 = this.checkDisable()
      if(ruler1) {
        return
      }
      laydate.render({
        elem: `#period_end${i}${sub}`
        ,lang: 'en'
        ,show:true
        ,value:e
        ,done:(value:any)=>{
          let val = value
          let data = {}
          //console.log("=>(check_lists-quest.component.ts:978) ", subitem);
          if(subitem.type === 'radio_sign_date'){
            data={
              sign_date:val,
              part:this.num,
              item:i,
              sub_item:sub
            }
          }else{
            data={
              value:val,
              part:this.num,
              item:i,
              sub_item:sub
            }
          }

          this.updateInfo(data)
        }
      });
  }
  signBox(i:any,sub:any,subitem:any){
    //console.log("=>(check_lists-quest.component.ts:1029) ", this.sign_box, this.dipslesignature);
    if(this.dipslesignature) return
    //console.log("=>(check_lists-quest.component.ts:1031) l", this.dipslesignature);
      this.sign_box.item = i
      this.sign_box.sub_item = sub
      this.sign_box.part = this.num
      this.isSignBoxItem = true
      this.dipslesignature = true
  }
  deleteSignBox(i:any,sub:any){
    const data={
      sign_id:0,
      part:this.num,
      item:i,
      sub_item:sub
    }
    this.updateInfo(data)
  }
  imageSrc(e:any){
    return location.origin + `/api/v3/logical_docs/doc/${e.sign_id}/stream`

  }
  newSelect(val:any,i:any,sub:any){
    let data={
      value:val.target.value,
      part:this.num,
      item:i,
      sub_item:sub
    }
    this.updateInfo(data)
  }

  addRemark(event:any,i:any){
    let data={
      remark:event.target.value,
      part:this.num,
      item:i
    }
    this.updateInfo(data)
  }
  showNote(item:any,i:any){
     if(this.checkDisable()){
      return
    }
    this.remarkFlag = true
    this.remark_item = item
    this.remark_id = i

  }

  uploadImg(item:any,i:any){
    if(this.checkDisable()){
      return
    }
    this.doc_item = item
    //如果不是同一个item
    this.doc_item_id = i

    this.uploadFileRef.nativeElement.click();
  }

  selectFile(event:any,item:any,i:any){
    this.showLoading = true
    let files = event.target.files;
    let file = new FormData();
    file.append('file', files[0]);
    this.service.update_img({
      p_id:this.id,
      c_id:this.check_listsID,
      file
    }).subscribe((res: any) => {
      if(this.doc_item.props.image){
        this.templateid = this.doc_item.props.image.concat ({
          doc_id:res.doc_id,
          status:''
        })
      }else{
        this.templateid.push({
          doc_id:res.doc_id,
          status:''
        })
      }
      let data={
        part:this.num,
        item:this.doc_item_id,
        image:this.templateid
      }
      this.updateInfo(data)
      this.templateid = []
      this.uploadFileRef.nativeElement.value = '';
      this.showLoading = false
    })
  }

  updateUserCheckList(datas:any){
    let data=datas
    this.service.updateCheckList({
      p_id:this.id,
      c_id:this.check_listsID,
      data:data
    }).subscribe((res: any) => {
    })
  }

  changesUser(e:any){
    if(e == 'null'){
      this.assigned_to_id = null
    }else{
      this.assigned_to_id = e
    }

    this.updateUserCheckList({assigned_to_id:this.assigned_to_id})
  }

  changeLocations(e:any){
    this.check_list_location_id = e
    if(e == 'null'){
      this.check_list_location_id = null
    }else{
      this.check_list_location_id = e
    }
    this.updateUserCheckList({check_list_location_id:this.check_list_location_id})
  }

  colseSign(e:any){
    if(e){
      this.signShow = false
      const that = this
      this.service.uploadFile({p_id:this.id,c_id:this.check_listsID,file:e}).subscribe((res:any)=>{
        // this.doc_idImg = `http://localhost:3000/api/v3/logical_docs/doc/${res.doc_id}/stream`
        this.doc_idImg = res.doc_id

        that.service.update_sign(that.check_listsID, {sign:that.autographsignitem,doc_id:res.doc_id}).subscribe((res:any)=>{
          that.getInfo()
        })
      })
    }else{
      this.signShow = false
    }

  }

  lodingqianming(index:any,item:any){
    // const currentUser: any = document.querySelector('meta[name=current_user]');
    // if(currentUser.dataset.name===this.signBy[index].username){
    //   this.signShow = true
    //   this.autographsignitem = index
    // }else{
    //   alert(`${this.i18n.t("js.check-lists.quest.NotSigner")}`)
    // }

      this.signShow = true
      this.autographsignitem = index

  }

  okTable(){
    this.updateUserCheckList({state:"finished"})
    this.data.check_list.state = "finished"
    this.show_banner = false
  }

  allLogShow() {
    if(this.data.check_list.state === 'Closed'|| this.data.check_list.state == 'Cancel' ||((this.data.check_list.created_by_id !=this.userId || (this.data.check_list.state != 'New' && !this.data.check_list.state.includes('Completed'))) && (this.data.check_list.assigned_to_id != this.userId || !this.data.check_list.state.includes('Sent')))) {
      return
    }
    this.allLog = !this.allLog
  }
  toEditpic(index:any,item:any,subitem:any,bigindex:any){
    this.doc_item_id = bigindex
    this.tempIndex = index
    this.templateid=item
    this.showEditDiv = true
    this.imageData = subitem
    this.imageLeftData.src = this.host+'/api/v3/logical_docs/doc/'+this.imageData.doc_id+'/stream.jpg'

  }
  goEdit(e:any){
    this.imageData.status = e.target.value
  }
  changeSign(name:any,e:any,index:any) {
    this.data.check_list[name] = e
    this.CurrentData[index].dateTime = e
    // if(name == 'submission') {
    //   this.data.check_list.submission_sign_at = e
    // } else if(name == 'inspection_first_sign_at') {
    //   this.data.check_list.inspection_first_sign_at = e
    // } else if(name == 'inspection_second_sign_at') {
    //   this.data.check_list.inspection_second_sign_at = e
    // }else if(name == 'fourth_sign_at') {
    //   this.data.check_list.fourth_sign_at = e
    // }else if(name == 'fifth_sign_at') {
    //   this.data.check_list.fifth_sign_at = e
    // }
  }
  firstRequirBoolean() {
    return !((this.data.check_list.state == 'New' || this.data.check_list.state == 'Recheck') && this.data.check_list.created_by_id == this.userId)
  }
  secondRequirBoolean() {
    return !((this.data.check_list.state == this.special_first_type) && this.data.check_list.assigned_to_id == this.userId)
  }
  thirdRequirBoolean() {
    return!((this.data.check_list.state =='site agent signed') && this.data.check_list.assigned_to_last_id == this.userId)
  }
  fourthRequirBoolean() {
    return!((this.data.check_list.state =='supervisor checked') && this.data.check_list.fourth_sign_user_id == this.userId)
  }
  fifthRequirBoolean() {
    return!((this.data.check_list.state =='supervisor_1 signed') && this.data.check_list.fifth_sign_user_id == this.userId)
  }
  actionreplayBoolean() {
   return (!this.data.check_list.state.includes(this.special_first_type)||  this.data.check_list.recheck == 'recheck'  || (this.data.check_list.assigned_to_id != this.userId && this.data.check_list.executor_id != this.userId))
  }
  actionreplay2Boolean() {
    const data = ['site agent signed']
    return(!data.includes(this.data.check_list.state) || !(this.data.check_list.assigned_to_id == this.userId))
  }
  checkObj(a:any){
    for (var i in a) {
      return true
    }
    return false
  }
  goDelete(){
    var msg = "确定删除图片吗?";
    if (confirm(msg)==true){
     this.templateid.splice(this.tempIndex,1)
    }
    let data={
      part:this.num,
      item:this.doc_item_id,
      image:this.templateid
    }
    this.updateInfo(data)
    this.showEditDiv = false
  }
  closeBtn(){
    this.showEditDiv = false
    this.showimgEdit=false
    this.templateid = []

  }
  confirmEdit(){
    this.showLoading = true
    this.showimgEdit=false
    if(this.imageData.status =='before'){
      this.imageData.following_action_token =''
    }else{
      this.imageData.finding = ''
      this.imageData.location = ''
    }
    this.templateid[this.tempIndex] = this.imageData
    let data={
        part:this.num,
        item:this.doc_item_id,
        image:this.templateid
      }
      this.updateInfo(data)

    this.showEditDiv = false
    this.showLoading = false
    this.templateid = []

  }
  checkSign(type:any) {
    if(type == 'action') {
      if((this.data.check_list.state!='New' && !this.data.check_list.state.includes('Completed') && !!this.data.check_list.recheck == false ) || this.data.check_list.created_by_id != this.userId ) {
        return false
      }
    } else if(type == 'second'){
        return (this.data.check_list.assigned_to_id == this.userId  && this.data.check_list.state.includes(this.special_first_type))
      } else if(type =='third' ){
        return (this.data.check_list.assigned_to_last_id == this.userId) && this.data.check_list.state.includes('site agent signed')
     }else if(type =='fourth'){
        return (this.data.check_list.fourth_sign_user_id == this.userId) && this.data.check_list.state.includes('supervisor checked')
     }else if (type =='fifth'){
      return (this.data.check_list.fifth_sign_user_id == this.userId) && this.data.check_list.state.includes('supervisor_1 signed')
     }else {
      if((this.data.check_list.executor_last_id != this.userId && this.data.check_list.assigned_to_last_id != this.userId||  this.data.check_list.recheck == 'recheck_two' ) || (!this.data.check_list.state.includes('Completed') && this.data.check_list.state !='ConsApproving')) {
        return false
      }
    }
    return true
  }
  displaysign(index:any){
    if(!this.CurrentData[index].disabled){
      return
    }
      this.signType = index
      this.dipslesignature = true
  }
  cleon(){
    this.removeDownLoadIframe()
    this.close.emit()
    if(window.location.href.indexOf('check_listsID')>0){
      let newUrl = window.location.href.split('?')[0]+'?kind_id='+this.kind_id
      window.history.replaceState(null, '', newUrl)
    }
  }

  // wanchengpardclick(item:any){
  //   this.showNum = true
  //   let needWrite:any=[]
  //   let state
  //   let count:any=0
  //   let sumcount:any=0
  //   let part = this.num
  //   for(let k in item){
  //     //计算必填项的数
  //     for(let subitem of item[k].list){
  //       sumcount++
  //       if(subitem.necessary){
  //         needWrite.push(subitem.title)
  //       }
  //       if(subitem.necessary&&(subitem.value||typeof(subitem.value)=='number')){
  //         count++
  //       }

  //     }
  //   }
  //   this.needNum=needWrite.length-count
  //   this.hascount = sumcount-count
  //     if(count==needWrite.length){
  //       state = 'finished'
  //       jQuery('.CompleteSelectedSection__items-remaining').css({'color':'#819099'});
  //       this.service.update_part_state({p_id:this.id,c_id:this.check_listsID,data:{part,state}}).subscribe((res:any)=>{
  //         this.getInfo()
  //             this.hascount =0
  //       })
  //     }else{
  //       state = 'pending'
  //       jQuery('.CompleteSelectedSection__items-remaining').css({'color':'red'});
  //     }
  // }
  wanchengpardclick(item:any){
    this.showNum = true
    let needWrite:any=[]
    let needWriteAll:any=[]
    let state
    let count:any=0
    let sumcount:any=0
    let countAll:any=0
    let sumcountAll:any=0
    let part = this.num
    console.log(item,'问题');

    for(let k in item){
      //计算必填项的数
      for(let subitem of item[k].list){
        sumcount++
        if(subitem.necessary && subitem.type!='unique_date'){
          needWrite.push(subitem.title)
        }
        if(subitem.necessary&&(subitem.value||typeof(subitem.value)=='number')){
          count++
        }

      }
    }
    this.needNum=needWrite.length-count
    this.hascount = sumcount-count
      if(count==needWrite.length){
        state = 'finished'
        let  complete = true
        this.data.check_list.check_list_metum.parts.forEach( (item:any, num:any) => {
          for(let k in item.items){
            //计算必填项的数
            for(let subitem of item.items[k].list){
              sumcountAll++
              if(subitem.necessary){
                needWriteAll.push(subitem.title)
              }
              if(subitem.necessary&&(subitem.value||typeof(subitem.value)=='number')){
                countAll++
              }

            }
          }
          //console.log(countAll, needWriteAll)
          if(countAll !== needWriteAll.length) {
            complete = false
          }
          needWriteAll = []
          countAll = 0
        })
        jQuery('.CompleteSelectedSection__items-remaining').css({'color':'#819099'});
        this.service.update_part_state({ p_id:this.id,c_id:this.check_listsID,data:{part,state,'complete?': complete}}).subscribe((res:any)=>{
          this.getInfo()
              this.hascount =0
        })
      }else{
        state = 'pending'
        jQuery('.CompleteSelectedSection__items-remaining').css({'color':'red'});
      }
  }
  autograph(username:any,finished_at:any){
    let text
    if(this.i18n.locale == 'en'){
      text = `Signed by ${username} from Chun Wo on ${finished_at}`
    }else if(this.i18n.locale == 'zh-CN' || this.i18n.locale == 'zh-TW'){
      text = `由${username}于${finished_at}签名`
    }
    return text
  }

  issueclone(){
    this.issueblock=false
  }
  //获取新增task fileRefNo 数据
  public getFileRefNo(project_id: string) {
    this.kind_id = location.search.split('?')[1].split('&')[0].split('=')[1]
    const type = this.checklistArr[this.kind_id];
    this.service.fileRefNo(project_id,type).subscribe((res:any) => {
      this.zone.run(() => {
        if (res.data.is_dwss_type) {
          this.isFileRefNo = true;
          this.fileRefNo = res.data;
          if (res.data.values.length > 0) {
            this.fileRefNoType = this.getStringValue(res.data.values[0].value) || "";
          }
          // this.hook.globalVar.next([{ prefix:this.fileRefNo.prefix,type_value: this.fileRefNoType}]);
        } else {
          this.isFileRefNo = false;
        }
      });
    });
  }

  //获取task fileRefNo 数据
  public getFileRefNoInfo() {
    const obj_id = this.check_listsID;
    this.kind_id = location.search.split('?')[1].split('&')[0].split('=')[1]
    const obj_type =this.checklistArr[this.kind_id] ;
    this.service.fileRefNoInfo(obj_id, obj_type).subscribe((res:any) => {
      this.zone.run(() => {
        if (res.is_dwss_type) {
          this.isFileRefNo = true;
          this.fileRefNoInfo = res.data;
          this.fileRefNo = {};
        } else {
          this.getFileRefNo(this.id);
          this.isFileRefNo = false;
        }
      });
    });
  }

  //提交refno
  public saveFileRefNo() {
    const obj_type: string = 'CheckList' ;
    let fileRefNoType = JSON.parse(this.fileRefNoType)
    this.service
      .saveFileRefNo({
        obj_id: this.check_listsID,
        obj_type,
        prefix: this.fileRefNo.prefix,
        type_value: fileRefNoType,
      })
      .subscribe((res:any) => {
        if (res.result == "ok") {
          this.getFileRefNoInfo();
        } else {
          alert(res.reason);
        }
        this.service.getCheckList(this.id,this.check_listsID).subscribe((res: any) => {
          this.data.check_list.file_ref_no = res.check_list.file_ref_no
          this.saveFileFlag = false
        })
      });

    }

  //适配手机端
  asideClick(e:boolean){
    let diviceWidth = document.documentElement.clientWidth;
    if(diviceWidth>310&&diviceWidth<770){
      if(e){
        jQuery(".content-date-left").css("display","block")
        jQuery(".content-detailed").css("display","none")
        jQuery(".asideHide").css("display","block")
        jQuery(".asideShow").css("display","none")
        jQuery(".detailShow").css("display","block")
      }else{
        jQuery(".content-date-left").css("display","none")
        jQuery(".asideShow").css("display","block")
        jQuery(".asideHide").css("display","none")
      }
    }
  }

  detailClick(e:any){
    let diviceWidth = document.documentElement.clientWidth;
    if(diviceWidth>310&&diviceWidth<770){
      if(e){
        jQuery(".content-detailed").css("display","block")
        jQuery(".content-date-left").css("display","none")
        jQuery(".detailShow").css("display","none")
        jQuery(".asideShow").css("display","block")
        jQuery(".asideHide").css("display","none")

      }else{
        jQuery(".content-detailed").css("display","none")
        jQuery(".detailShow").css("display","block")

      }
    }
  }

  //切换的字体颜色问题
   changeNum(e:any){
     this.num +=e
     jQuery('.CompleteSelectedSection__items-remaining').css({'color':'#819099'});
     this.showNum = false
   }
     //鼠标移入显示
  showAftername(i:any){
    let aftername:any = document.querySelectorAll(".aftername")
    aftername[i].style.display ="inline-block"
  }
  hideAftername(i:any){
    let aftername:any = document.querySelectorAll(".aftername")
    aftername[i].style.display ="none"
  }


}
